<div class="ap-impact">
    <p class="ap-section-label">{{ section.label }}</p>
    <app-alert-block type="success" class="ap-impact-panel">
        <p class="ap-impact-primary">{{ displayPrimary }}</p>
        <p class="ap-impact-secondary" *ngIf="displaySecondary">{{ displaySecondary }}</p>
    </app-alert-block>
</div>
